// extracted by mini-css-extract-plugin
export default {"root":"efjiohcOuHVNs6em3tch"};